export enum ItemReplacementStatusCode {
  AwaitingCredit = 'AWAIT-CRED',
  CreditReceived = 'CRED-RCVD',
  InProcess = 'IN-PROCESS',
  None = 'NONE'
}
